import { render, staticRenderFns } from "./code-redeem-success.vue?vue&type=template&id=90d0d676&"
import script from "./code-redeem-success.vue?vue&type=script&lang=js&"
export * from "./code-redeem-success.vue?vue&type=script&lang=js&"
import style0 from "./code-redeem-success.vue?vue&type=style&index=0&id=90d0d676&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports